import { Card, CardHeader, CardTitle } from '@/shared/components/ui/card'
import { Badge } from '@/shared/components/ui/badge'
import { safeFormatDateTime } from '@/shared/utils/formatDate'
import { LICENSE_TYPE_LABELS, labelOf } from '@/shared/constants'
import type { MyOrganization } from '../hooks/useMyOrganization'

interface OrganizationDetailsCardProps {
  organization: NonNullable<MyOrganization>
}

function Field({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs uppercase tracking-wide text-ink-subtle">{label}</span>
      <span className="text-sm font-medium text-ink">{value || '—'}</span>
    </div>
  )
}

export function OrganizationDetailsCard({ organization }: OrganizationDetailsCardProps) {
  const licenseLabel = labelOf(LICENSE_TYPE_LABELS, organization.licenseType)

  return (
    <Card>
      <CardHeader>
        <CardTitle>Datos de la organización</CardTitle>
      </CardHeader>

      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Descripción" value={organization.description} />
        <Field label="Tipo de facturación" value={licenseLabel} />
        <Field
          label="Día de cobro"
          value={organization.plannedDayToPay ? `Día ${organization.plannedDayToPay}` : ''}
        />
        <Field label="Licencia hasta" value={safeFormatDateTime(organization.licenceUntil)} />
        <Field label="Creada" value={safeFormatDateTime(organization.createdAt)} />
        <Field
          label="Categorías"
          value={
            organization.categories?.length
              ? (
                <div className="flex flex-wrap gap-1.5">
                  {organization.categories
                    .filter((c): c is { id: number; name: string } => Boolean(c))
                    .map((c) => (
                      <Badge key={c.id} variant="accent">
                        {c.name}
                      </Badge>
                    ))}
                </div>
              )
              : ''
          }
        />
      </div>
    </Card>
  )
}
